































import { Component, Vue } from 'vue-property-decorator'
import usersApi from '@/api/users'
import {
    IUserAdminRightsSection,
    IUserGeneralAndContactInfoSection,
    UserCreateDto
} from "@/global";
import * as enums from "@/global-enum";
import Helpers from "@/helpers";
import UserGeneralAndContactInfoSection from "@/views/user/UserGeneralAndContactInfoSection.vue";
import UserAdminRightsSection from "@/views/admin-access/UserAdminRightsSection.vue";
import {AuthModule} from "@/store/modules/auth";

@Component({
    components: {
        UserGeneralAndContactInfoSection, UserAdminRightsSection
    }
})
export default class CreateUser extends Vue {
    isLoading = true;
    isButtonsDisabled = false;
    user: UserCreateDto | null = null;

    mounted() {
        // invite key is empty
        if (!this.$helpers.isNotEmpty(this.$route.params.key)) {
            this.$router.push({ name: 'login' });
            return;
        }

        const thisInst = this;
        this.initData(() => {
            thisInst.$nextTick(async () => {
                await thisInst.getGeneralAndContactInfoSection().afterDataInit();

                if (thisInst.isAdminWithUsersAccess) {
                    await thisInst.getUserAdminRightsSection().afterDataInit();
                }

                this.isLoading = false;
            });
        });
    }

    getGeneralAndContactInfoSection() {
        return this.$refs.generalAndContactInfoSection as unknown as IUserGeneralAndContactInfoSection;
    }

    getUserAdminRightsSection() {
        return this.$refs.userAdminRightsSection as unknown as IUserAdminRightsSection;
    }

    // computed
    get validateForm(): boolean {
        return !this.veeErrors.any();
    }

    get isAdminWithUsersAccess() {
        const userInfo = AuthModule.obtainUserInfo();
        return this.$helpers.isExists(userInfo) &&
            this.$helpers.anyInArray(userInfo!.accesses, x =>
                x.type === enums.UserAccessType_SystemAdmin ||
                x.type === enums.UserAccessType_Users);
    }

    // methods
    validateState(ref: string) {
        if (this.veeFields[ref] &&
            (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
            return !this.veeErrors.has(ref);
        }

        return null
    }

    showError(errorMessage?: string) {
        this.$bvToast.toast(errorMessage || "Спробуйте пізніше", {
            title: "Помилка",
            variant: "danger"
        })
    }

    initData(afterUserInit: () => void) {
        this.isLoading = true;

        usersApi.getUserCreate(this.$route.params.key, (u) => {
            this.user = u;

            if (this.user.availableOrganizations.length === 1) {
                this.user.organizationId = this.user.availableOrganizations[0].id;
            }

            afterUserInit();
        }, errorMessage => {
            this.showError(errorMessage);

            // go to login page if error
            this.$router.push({ name: 'login' });
        });

        afterUserInit();
    }

    async createUser() {
        this.isButtonsDisabled = true;

        let isValid = true;

        if (!await this.getGeneralAndContactInfoSection().validateAll()) {
            isValid = false;
        }

        if (this.isAdminWithUsersAccess && !await this.getUserAdminRightsSection().validateAll()) {
            isValid = false;
        }

        if (!await this.$validator.validateAll()) {
            isValid = false;
        }

        if (isValid) {
            usersApi.createUser(this.user!, (data) => {
                if (data.success) {
                    this.$router.push({ name: 'login' })
                } else {
                    this.showError();
                }
            }, errorMessage => {
                this.isButtonsDisabled = false;

                this.showError(errorMessage);
            });
        } else {
            this.isButtonsDisabled = false;
        }
    }

    closePageWithConfirm() {
        this.$bvModal.msgBoxConfirm(`Ви дійсно хочете скасувати регістрацію та закрити вікно?`, {
            title: `Скасувати регістрацію абонента`,
            size: 'sm',
            okVariant: 'danger',
            okTitle: 'Скасувати',
            cancelTitle: 'Відміна',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
        })
            .then(value => {
                if (value) {
                    window.close();
                }
            })
            .catch(err => {
                // An error occurred
            })
    }
}
